import React from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context";
import { AppProvider } from "./context";
import AppRouter from "./router/AppRouter";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppProvider>
          <AppRouter />
        </AppProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
